<script lang="ts">
    import {getInjector} from 'src/core';
    import {Flex} from 'shared/layouts';
    import type {Rec} from 'src/typings';
    import {popInAnim, popOutAnim} from 'shared/animations';
    import type {DynamicFieldSearchParam, RecordRow, RowCreationParams} from 'src/features/record-grid/lib/types';
    import {createProjectLogbookPairingContext} from './project-logbook-pairing-context';
    import {ProjectLogbookPairingService} from './project-logbook-pairing.service';
    import {onDestroy} from 'svelte';
    import {exists} from 'shared/utils/custom-utils';
    import {SUTOR_LOGBOOK_PAIRING_PAGE} from 'src/features/erp-sutor/sutor-constants';
    import LogbookPairingSplit from './LogbookPairingSplit.svelte';
    import LogbookPairingRowOptionsCell from './LogbookPairingRowOptionsCell.svelte';
    import KpRecordGrid from 'src/features/record-grid/KpRecordGrid.svelte';
    import KpButton from 'shared/ui-widgets/button/KpButton.svelte';
    import IconedContent from 'shared/ui-widgets/uicons/IconedContent.svelte';

    export let record: Rec;

    const service = getInjector().getByClass(ProjectLogbookPairingService);
    const context = createProjectLogbookPairingContext(record, service);

    let openedLogbook: RecordRow | null = null;
    const openedLogbookUnsubscribe = context.openedLogbook$.subscribe((currentOpenedLogbook) => openedLogbook = currentOpenedLogbook);
    const dynamicFieldSearchParams: DynamicFieldSearchParam[] = [{
        fieldTypeId: SUTOR_LOGBOOK_PAIRING_PAGE.logbookReferenceField,
        type: 'link',
        value: context.projectRecord.id
    }]
    const rowCreationParams: RowCreationParams = {initialValues: {[SUTOR_LOGBOOK_PAIRING_PAGE.logbookReferenceField]: {recordId: context.projectRecord.id}}}

    onDestroy(() => {
        openedLogbookUnsubscribe();
    });

    const handleOpenBatchExportModalClick = async () => {
        await context.service.openBatchExportLogbooksToProjectFilesModal(context.projectRecord);
    };
</script>

<Flex class="sutor-logbook-pairing" direction="column" fillAvailableSpace>
    <div class="overlay-container">
        {#if !exists(openedLogbook)}
            <div class="grid-container record-grid-tab-page"
                 in:popInAnim={{key: 'grid'}}
                 out:popOutAnim={{key: 'grid'}}>

                <div class="action-buttons-container">
                    <KpButton buttonStyle="brand-orange" on:click={handleOpenBatchExportModalClick}>
                        <IconedContent icon="file-export">
                            Hromadný export do souborů zakázky
                        </IconedContent>
                    </KpButton>
                </div>

                <KpRecordGrid rowOptionsCellComponent={LogbookPairingRowOptionsCell}
                              fondOrFondId={SUTOR_LOGBOOK_PAIRING_PAGE.logbooksFond}
                              referenceRecordId={context.projectRecord.id}
                              {dynamicFieldSearchParams}
                              {rowCreationParams}
                              infiniteScroll/>
            </div>
        {:else}
            <div class="reports-container"
                 in:popInAnim={{key: 'logbook-reports'}}
                 out:popOutAnim={{key: 'logbook-reports'}}>

                <LogbookPairingSplit {openedLogbook}/>
            </div>
        {/if}
    </div>
</Flex>

<style lang="less">
    @import (reference) "styles/portaro-erp.less";
    @import (reference) "styles/portaro.variables.less";

    .overlay-container {
        .flex-grow();
        position: relative;

        .grid-container,
        .reports-container {
            .flex-grow();
            align-items: start;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
        }
    }

    .action-buttons-container {
        padding-inline: @spacing-xxl;
        padding-top: @spacing-ml;
    }
</style>